module.exports = __webpack_public_path__ + "img/img008.2a33b77f.png";